import React from "react";

import { useNavigate } from "react-router-dom";

import { ReportLink } from "../shared/SectionCard";

import { PartnerProgramAwardIcon } from "../shared/adminHomeIcons";

import type { PartnerProgramData } from "../../types";

type AdminPartnerProgramCardProps = {
  data: PartnerProgramData;
  showReportLink?: boolean;
};

const AdminPartnerProgramCard: React.FC<AdminPartnerProgramCardProps> = ({
  data,
  showReportLink = false,
}) => {
  const { totalPartners, tiers, evaluationYear } = data;

  const navigate = useNavigate();

  const handlePartnerTier = (tierName: string) => {
    navigate("/hid-admin/dashboard/partner-organizations", {
      state: {
        partnerTierFilter: tierName,
      },
    });

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  return (
    <section className="admin-home-program">
      <div className="admin-home-program__header">
        <h3 className="admin-home-program__title">Partner Program</h3>

        <div className="admin-home-program__eval-row">
          <div className="admin-home-program__eval-text">
            <span className="admin-home-program__eval-label">
              Total Partner
            </span>

            <span className="admin-home-program__eval-year">
              IN CURRENT YEAR ({evaluationYear})
            </span>
          </div>

          <span className="admin-home-program__eval-value">
            {totalPartners.toLocaleString("en-US")}
          </span>
        </div>
      </div>

      <ul className="admin-home-program__tiers">
        {tiers.map((tier) => (
          <li
            key={tier.id}
            className="admin-home-program__tier"
            style={{ cursor: "pointer" }}
            onClick={() => handlePartnerTier(tier.label)}
          >
            <span
              className="admin-home-program__tier-icon"
              style={{ backgroundColor: tier.color }}
              aria-hidden
            >
              <PartnerProgramAwardIcon width={16} height={16} />
            </span>

            <span className="admin-home-program__tier-label">{tier.label}</span>

            <span className="admin-home-program__tier-count">{tier.count}</span>
          </li>
        ))}
      </ul>

      {showReportLink ? (
        <div className="admin-home-program__footer">
          <ReportLink label="View Program Report" />
        </div>
      ) : null}
    </section>
  );
};

export default AdminPartnerProgramCard;
